export const missionListContainerSx = { display: 'flex', flexFlow: 'row wrap' };
